import { TreeNode } from "primereact/treenode";
export const insightsCollection: TreeNode[] = [
  {
    key: "brainstorm",
    icon: "pi pi-comments",
    data: { title: "Brainstorm", key: "brainstorm" },
    label:
      "Brainstorm: AI-assisteret brainstorming til at bygge din FocusMap struktur",
    selectable: true,
  },
  {
    key: "chatgpt",
    icon: "pi pi-lightbulb",
    data: { title: "ChatGPT", key: "chatgpt" },
    label:
      "ChatGPT: AI model for text-based conversation and information retrieval (int)",
    selectable: false,
  },
  {
    key: "pubmed",
    icon: "pi pi-lightbulb",
    data: { title: "PubMed", key: "pubmed" },
    label: "PubMed: A free database for life sciences research (int)",
    selectable: false,
  },
  {
    key: "cvr",
    icon: "pi pi-lightbulb",
    data: { title: "CVR", key: "cvr" },
    label: "CVR: Offentligt register over danske firmaer (dk)",
    selectable: false,
  },
  {
    key: "tinglysning",
    icon: "pi pi-lightbulb",
    data: { title: "Tinglysning", key: "tinglysning" },
    label: "Tinglysning: Offentligt register over ejerskab og rettigheder (dk)",
    selectable: false,
  },
  {
    key: "statstidende",
    icon: "pi pi-lightbulb",
    data: { title: "Statstidende", key: "statstidende" },
    label:
      "Statstidende: Officiel dansk publikation for meddelelser og bekendtgørelser (dk)",
    selectable: false,
  },
  {
    key: "retsinformation",
    icon: "pi pi-lightbulb",
    data: { title: "Retsinformation", key: "retsinformation" },
    label:
      "Retsinformation: Officiel dansk portal for love, bekendtgørelser og retspraksis (dk)",
    selectable: false,
  },
  {
    key: "biq",
    icon: "pi pi-lightbulb",
    data: { title: "BIQ", key: "biq" },
    label:
      "BIQ: Dansk erhvervsdatabase med information om virksomheder og personer (dk)",
    selectable: false,
  },
];
